import React from 'react';
import { AlertCircle, X } from 'lucide-react';

interface ProfileUnauthenticatedProps {
  onClose?: () => void;
  isModal?: boolean;
}

export const ProfileUnauthenticated: React.FC<ProfileUnauthenticatedProps> = ({
  onClose,
  isModal = false,
}) => {
  if (!isModal) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-xs p-4">
      <div className="bg-white rounded-3xl p-8 border border-slate-200 text-center max-w-lg w-full shadow-2xl relative">
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label="Tutup"
            className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-full hover:bg-slate-100 cursor-pointer"
          >
            <X className="w-5 h-5" />
          </button>
        )}
        <div className="w-12 h-12 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-4">
          <AlertCircle className="w-6 h-6" />
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-2">Sesi Masuk Diperlukan</h3>
        <p className="text-sm text-slate-500 mb-6">
          Silakan masuk ke akun Anda terlebih dahulu untuk melihat dan mengelola profil akun UIBN.
        </p>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold rounded-xl text-xs transition cursor-pointer"
          >
            Tutup
          </button>
        )}
      </div>
    </div>
  );
};
